<template>
  <el-container class="purchaser-sales">
    <el-header height="40px">
      <el-form inline>
        <el-form-item>
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            align="right"
            :default-time="['00:00:00', '23:59:59']"
            :editable="false"
            :clearable="false"
            :disabled="passDateRange && passDateRange.length == 2"
          />
        </el-form-item>
        <el-form-item label="客户">
          <el-input v-model="queryParam.purchaserName" @clear="query" @keydown.enter.native="query" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-refresh" @click="query">查询</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main>
      <div class="chart-container">
        <div id="barChartArea" ref="barChartArea" style="width: 100%; height: 350px" />
      </div>
      <grid-table
        ref="gridTable"
        :tableConfig="tableConfig"
        :showIndexColumn="false"
        :showLastEmptyColumn="false"
        :showPagination="true"
        :showCheckboxColumn="false"
      >
        <template slot="TakedRate" slot-scope="{ params }"> {{ params.row.TakedRate }}% </template>
        <template slot="ReturnRate" slot-scope="{ params }"> {{ params.row.ReturnRate }}% </template>
        <template slot="Operate" slot-scope="{ params }">
          <el-link v-if="params.row.ProductID" type="primary" :underline="false" @click.native.stop="handleRowOperation(params.row)">
            查看详情
          </el-link>
        </template>
      </grid-table>
    </el-main>
    <el-drawer
      :title="'客户：' + detailView.purchaserName"
      :visible.sync="detailView.visible"
      size="85%"
      custom-class="detail-view"
      destroy-on-close
    >
      <el-tabs v-model="detailView.curTab">
        <el-tab-pane label="商品明细" name="productList">
          <producttrade-analysis :purchaserID="detailView.purchaserID" :passDateRange="dateRange"></producttrade-analysis>
        </el-tab-pane>
        <el-tab-pane label="日期明细" name="dateList">
          <dailysales-analysis :purchaserID="detailView.purchaserID" :passDateRange="dateRange"></dailysales-analysis>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
  </el-container>
</template>

<script>
import dayjs from 'dayjs'
import * as echarts from 'echarts'
import { getDatePickerOptions } from '@/utils/tool'

export default {
  name: 'customerAnalysis',
  components: {
    ProducttradeAnalysis: () => import('./producttradeAnalysis.vue'),
    DailysalesAnalysis: () => import('./dailysalesAnalysis.vue'),
  },
  props: {
    productID: Number,
    passDateRange: Array,
  },
  beforeMount() {
    if (this.productID) {
      this.tableConfig.columns[8].isHidden = true
    }
    if (this.productID || this.passDateRange) {
      this.tableConfig.columns[12].isHidden = true
    }
    if (this.passDateRange && this.passDateRange.length == 2) {
      this.dateRange = this.passDateRange
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.query()
    })
    // 添加窗口resize监听
    window.addEventListener('resize', this.handleResize)
  },
  data() {
    return {
      loading: false,
      queryParam: {
        groupType: 'purchaser',
        startTime: '',
        endTime: '',
        productID: null,
        purchaserName: null,
      },
      dateRange: [dayjs().subtract(7, 'day').format('YYYY-MM-DD 00:00:00'), dayjs().format('YYYY-MM-DD 23:59:59')],
      pickerOptions: getDatePickerOptions(true),
      tableConfig: {
        url: '/api/dataReport/getSalesList',
        rowKey: 'PurchaserID',
        columns: [
          { label: '客户', prop: 'PurchaserName', type: 'text' },
          { label: '报单数', prop: 'Num', type: 'text', width: '130px' },
          { label: '拿货数', prop: 'TakedNum', type: 'text', width: '130px', sortType: 'custom' },
          { label: '退货数', prop: 'ReturnNum', type: 'text', width: '130px', sortType: 'custom' },
          { label: '拿货率', prop: 'TakedRate', type: 'custom-operation', width: '130px', sortType: 'custom' },
          { label: '退货率', prop: 'ReturnRate', type: 'custom-operation', width: '130px', sortType: 'custom' },
          { label: '拿货金额', prop: 'Payment', type: 'text', width: '130px', sortType: 'custom' },
          { label: '退货金额', prop: 'RefundFee', type: 'text', width: '130px', sortType: 'custom' },
          { label: '收银金额', prop: 'CashFee', type: 'text', width: '130px', sortType: 'custom' },
          { label: '拿货成本', prop: 'TakedCost', type: 'text', width: '130px' },
          { label: '退货成本', prop: 'RefundCost', type: 'text', width: '130px' },
          { label: '利润', prop: 'Profit', type: 'text', width: '130px', sortType: 'custom' },
          { label: '操作', prop: 'Operate', type: 'custom-operation', width: '130px' },
        ],
      },
      barChartInstance: null,
      barChartData: [],
      detailView: {
        visible: false,
        curTab: 'productList',
        purchaserID: null,
        purchaserName: null,
      },
    }
  },
  methods: {
    async query() {
      this.queryParam.startTime = this.dateRange[0]
      this.queryParam.endTime = this.dateRange[1]
      this.queryParam.productID = this.productID || null
      this.$refs.gridTable.fetchData(
        false,
        datas => {
          this.barChartData = datas
          this.$nextTick(() => {
            this.renderBarChart()
          })
        },
        this.queryParam,
        true
      )
    },
    renderBarChart() {
      // 销毁现有柱状图
      if (this.barChartInstance) {
        this.barChartInstance.dispose()
      }
      if (!this.$refs.barChartArea) return

      this.$nextTick(() => {
        // 获取容器实际宽度
        const containerWidth = this.$refs.barChartArea.clientWidth
        if (containerWidth == 0) {
          setTimeout(() => {
            this.renderBarChart()
          }, 100)
          return
        }

        // 初始化柱状图
        this.barChartInstance = echarts.init(this.$refs.barChartArea)
        const option = this.generateBarChartOption()
        this.barChartInstance.setOption(option)

        // 使用ResizeObserver监听容器尺寸变化
        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(() => {
            if (this.barChartInstance) {
              this.barChartInstance.resize()
            }
          })
          this.resizeObserver.observe(this.$refs.barChartArea)
        }
      })
    },
    generateBarChartOption() {
      const tableData = this.barChartData
      const xAxisData = []
      const takedNumData = [] // 销售数量
      tableData.forEach(item => {
        if (item.PurchaserName != '合计') {
          xAxisData.push(item.PurchaserName) // 客户
          takedNumData.push(item.TakedNum || 0) // 销售数量
        }
      })
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: 80,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLabel: {
            rotate: 45,
            interval: 0,
            formatter: (value, index) => {
              return `{name|${value}}`
            },
            rich: {
              name: {
                textDecoration: 'underline',
                fontSize: 12,
              },
            },
            name: '客户',
          },
        },
        yAxis: {
          type: 'value',
          name: '拿货数',
        },
        series: [
          {
            name: '拿货数',
            type: 'bar',
            data: takedNumData,
            itemStyle: {
              color: '#409EFF',
            },
          },
        ],
      }
    },
    handleRowOperation(row) {
      this.detailView.purchaserID = row.PurchaserID
      this.detailView.purchaserName = row.PurchaserName
      this.detailView.visible = true
    },
    beforeDestroy() {
      if (this.barChartInstance) {
        this.barChartInstance.dispose()
      }
      // 移除窗口resize监听
      window.removeEventListener('resize', this.handleResize)
    },
    // 处理窗口resize
    handleResize() {
      if (this.barChartInstance) {
        this.barChartInstance.resize()
      }
    },
  },
}
</script>

<style lang="scss">
.detail-view {
  .el-drawer__header {
    margin-bottom: 0;
    padding: 10px 10px 8px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }

  .el-tabs {
    padding-top: 0 !important;
  }
}
</style>

<style lang="scss" scoped>
.purchaser-sales {
  padding: 5px;
}
.el-tabs {
  padding: 20px;
}
</style>
